<template>
  <!--eslint-disable-->
  <v-card flat class="pa-3 mt-2 main-theme">
    <v-card-title>
      <v-btn
        class="mx-2 contacts--button"
        color="error"
        text
        v-if="isAdmin"
        @click="$router.back()"
      >
        <v-icon class="mx-2"> arrow_back </v-icon>
        Back
      </v-btn>
      <v-spacer />
      <v-btn
        class="me-3"
        color="primary"
        elevation="0"
        v-if="isAdmin"
        @click="resetPassword"
      >
        Send Password Reset Link
      </v-btn>
      <v-btn
        class="me-3"
        color="error"
        elevation="0"
        v-if="isAdmin"
        @click="deleteUser"
      >
        Delete
      </v-btn>
    </v-card-title>
    <v-divider class="mb-4" v-if="isAdmin" />
    <v-row class="mx-1">
      <v-col cols="12" md="2" class="d-flex justify-center">
        <v-avatar rounded size="120" class="me-6">
          <v-img
            v-if="accountData && !accountData.base64Image"
            src="../../../../assets/images/2.png"
          />
          <v-img
            v-else
            :src="`data:${getImage(accountData.base64Image)};base64, ${
              accountData.base64Image
            }`"
          />
        </v-avatar>
        <!-- upload photo -->
      </v-col>
      <v-col cols="12" md="3" v-if="!isAdmin">
        <v-file-input
          prepend-icon=""
          type="file"
          rounded
          filled
          dense
          @change="uploadFile($event)"
          :background-color="`green`"
          id="fileUpload"
          placeholder="Upload New Photo"
          accept=".jpeg,.png,.jpg,GIF"
        />
        <p class="text-sm mt-5">Allowed JPG, GIF or PNG. Max size of 800K</p>
      </v-col>
      <v-col cols="12" md="7">
        <v-row>
          <v-col md="6" sm="6" cols="12">
            <v-text-field
              v-model="accountData['firstName']"
              label="First Name"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col md="6" sm="6" cols="12">
            <v-text-field
              v-model="accountData['secondName']"
              label="Middle Name"
              dense
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="6" cols="12" class="mt-n6">
            <v-text-field
              v-model="accountData['lastName']"
              label="Last Name"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6" class="mt-n6">
            <p class="text--primary mt-n3 mb-2">Gender</p>
            <v-radio-group
              row
              class="mt-0"
              hide-details
              v-model="accountData['gender']"
            >
              <v-radio
                v-for="gen in gender"
                :key="gen.name"
                :label="gen.name"
                :value="gen.name"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-card-text>
      <v-form
        class="multi-col-validation mt-6"
        ref="profileForm"
        v-model="isValid"
      >
        <v-row>
          <v-col md="4" sm="6" cols="12" class="mt-n6">
            <v-text-field
              v-model="accountData['email']"
              label="Private Email"
              dense
              :disabled="!isAdmin"
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
            sm="6"
            xs="12"
            align-self="center"
            class="mt-n6"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="accountData['dateOfBirth']"
                  label="Date of Birth"
                  prepend-inner-icon="mdi-calendar"
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="selectedDate"
                min="1950/01/01"
                :allowed-dates="
                  (date) => date <= new Date().toISOString().substr(0, 10)
                "
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4" sm="6" class="mt-n6">
            <v-text-field
              v-model="accountData['phoneNo']"
              label="Phone Number"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4" sm="6" class="mt-n6">
            <v-text-field
              v-model="accountData['studentID']"
              dense
              :disabled="!isAdmin"
              label="Registration Number"
              outlined
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4" sm="6" class="mt-n6">
            <v-text-field
              v-model="accountData['identificationDocumentNo']"
              dense
              label="ID Number"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="6" class="mt-n6">
            <v-file-input
              label="Upload Passport/ National ID"
              placeholder="ID"
              dense
              outlined
              type="file"
              v-model="accountData.base64Id"
              @change="uploadNationalID($event)"
              prepend-icon=""
              prepend-inner-icon="badge"
              accept="image/jpeg,image/png,application/pdf"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="green accent-4" dark label small>
                  {{ text || "ID/Passport " }}
                </v-chip>
              </template>
            </v-file-input>
          </v-col>
          <!--BEGIN the nationality-->
          <v-col cols="12" md="4" sm="6" class="mt-n6">
            <v-select
              v-model="nationalityCode"
              :items="countries"
              label="Nationality"
              item-text="name"
              item-value="code"
              dense
              outlined
              prepend-inner-icon="flag"
            ></v-select>
          </v-col>
          <!--END the nationality-->
          <!-- emergency contact information -->
          <!-- alert -->
        </v-row>
      </v-form>
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-spacer />
      <v-btn @click="updateProfile" class="me-3 mt-4 profile-btn">
        Save changes
      </v-btn>
      <v-btn
        color="error"
        outlined
        class="mt-4"
        type="reset"
        @click.prevent="resetForm"
      >
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/* eslint-disable */
import { mdiAlertOutline, mdiCloudUploadOutline } from "@mdi/js";
import helpers from "../../../dashboard/utils/helpers/helper.js";
import { AuthService } from "../../../dashboard/modules/auth";
export default {
  name: "AccountSettings",
  props: {
    accountData: {
      type: Object,
      default: () => {},
    },
    onClick: { type: Function },
    onClicked: { type: Function },
  },
  data() {
    const status = ["Active", "Inactive", "Pending", "Closed"];

    const accountDataLocale = "accountDataLocale";

    const resetForm = () => {
      accountDataLocale.value = {};
    };

    return {
      menu: false,
      isValid: false,
      base64Image: "",
      status,
      accountDataLocale,
      resetForm,
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
      gender: [
        {
          name: "Male",
          value: "male",
        },
        {
          name: "Female",
          value: "female",
        },
      ],
    };
  },
  computed: {
    selectedDate: {
      get() {
        return "";
      },
      set(value) {
        this.accountData.dateOfBirth = value;
      },
    },
    nationalityCode: {
      get() {
        return this.accountData["nationalityCode"];
      },
      set(value) {
        this.accountData.nationalityCode = value;
        this.accountData.countryCode = value;
      },
    },
    countries: function () {
      return this.$store.getters["Profile/setupGetter"]("countries");
    },
    isAdmin() {
      return AuthService.user.is_admin === 1;
    },
  },
  methods: {
    getImage(base64) {
      return helpers.detectMimeType(base64);
    },
    updateProfile() {
      let formData = {
        firstName: this.accountData.firstName,
        lastName: this.accountData.lastName,
        secondName: this.accountData.secondName,
        dateOfBirth: this.accountData.dateOfBirth,
        phoneNo: this.accountData.phoneNo,
        gender: this.accountData.gender,
        profileID: this.accountData.profileID,
        email: this.accountData.email,
        id_number: this.accountData.identificationDocumentNo,
        base64Id: this.accountData.base64Id,
      };
      this.$store.dispatch("Profile/editbiodata", { ...formData });
    },
    async uploadFile(event) {
      let attachment = await helpers.toBase64(event);
      this.base64Image = attachment.split(",")[1];
      let formData = {
        profileID: this.accountData.profileID,
        email: this.accountData.email,
        id_number: this.accountData.identificationDocumentNo,
        base64Image: this.base64Image,
      };
      this.$store.dispatch("Profile/editbiodata", { ...formData });
    },
    resetPassword() {
      let formData = {
        email: this.accountData.email,
      };
      this.onClick(formData);
    },
    deleteUser() {
      let id = this.$route.params.reg;
      this.onClicked(id);
    },
    async uploadNationalID(event) {
      let attachment = await helpers.toBase64(event);
      this.accountData.base64Id = attachment.split(",")[1];
    },
  },
};
</script>

<style scoped>
@import url("../../styles/settings.css");

::placeholder {
  color: white;
  opacity: 1;
}
</style>
